import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import store from '../store';

Vue.use(VueRouter);

function ensureAdminOrAnalyst(to, from, next) {
  if (store.getters.hasAdminRole || store.getters.hasAnalystRole) next();
  else next('/admin/instances');
}

function ensureAdminOrChuenaOrExt(to, from, next) {
  if (store.getters.hasAdminRole || store.getters.hasChuenaRole || store.getters.hasExtRole) next();
  else next('/admin/instances');
}

function ensureAdmin(to, from, next) {
  if (store.getters.hasAdminRole) next();
  else next('/admin/instances');
}

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
  },

  {
    path: '/error/unexpected',
    name: 'ErrorUnexpected',
    component: () => import('@/views/ErrorUnexpected.vue'),
    beforeEnter: (to, from, next) => {
      if (!from.name) next({ name: 'HomeView' });
      else next();
    },
  },

  {
    path: '/dahu',
    redirect: '/candidats-hors-ue-non-assimiles',
  },

  {
    path: '/candidats-hors-ue-non-assimiles',
    name: 'CHUENA',
    component: () => import('@/views/CHUENAIndex.vue'),
  },

  {
    path: '/candidats-hors-ue-non-assimiles/documents-upload',
    name: 'CHUENAPayment',
    component: () => import('@/views/CHUENADocumentsUpload.vue'),
  },

  {
    path: '/enf',
    name: 'GuestEnf',
    component: () => import('@/views/GuestAll.vue'),
    alias: ['/enr'],
  },

  {
    path: '/enfv',
    name: 'EnfV',
    component: () => import('@/views/EnfV.vue'),
    meta: { requiresAuth: true },
  },

  {
    path: '/pss',
    name: 'ParaView',
    component: () => import('@/views/ParaView.vue'),
  },

  {
    path: '/pss/demo',
    name: 'ParaDemo',
    component: () => import('@/views/ParaDemo.vue'),
  },

  {
    path: '/admin',
    redirect: '/admin/login',
  },

  {
    path: '/admin/management',
    name: 'AdminManagement',
    component: () => import('@/views/AdminManagement.vue'),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasAccessRole && store.getters.hasAdminRole) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },

  {
    path: '/admin/directors',
    name: 'AdminDirectors',
    component: () => import('@/views/AdminDirectors.vue'),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasAccessRole && store.getters.hasAdminRole) next();
      else next('/admin/instances');
    },
  },

  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('@/views/AdminLogin.vue'),
    beforeEnter: (to, from, next) => {
      if (store.getters.isAuth && store.getters.hasAccessRole) {
        next('/admin/instances');
      } else if (store.getters.isAuth) {
        next('/enfv');
      } else {
        next();
      }
    },
  },

  {
    path: '/admin/instances',
    name: 'AdminInstances',
    component: () => import('@/views/AdminInstances.vue'),
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if (store.getters.hasAccessRole) {
        next();
      } else {
        next('/');
      }
    },
  },

  {
    path: '/verify',
    name: 'VerifyUser',
    component: () => import('@/views/VerifyUser.vue'),
  },

  {
    path: '/admin/dahu/:instanceId',
    // name: 'AdminDahu',
    component: () => import('@/views/AdminDahu.vue'),
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminDahuCursus',
        component: () => import('@/views/AdminDahuCursus.vue'),
      },

      {
        path: 'cursus/:cursusId',
        name: 'AdminDahuRegistrations',
        component: () => import('@/views/AdminDahuRegistrations.vue'),
        props: true,
      },
    ],
    beforeEnter: (to, from, next) => {
      // eslint-disable-next-line max-len
      if (store.getters.hasAccessRole && (store.getters.hasAdminRole || store.getters.hasDahuRole || store.getters.hasExtRole)) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },

  {
    path: '/admin/chuena/:instanceId',
    component: () => import('@/views/AdminChuena.vue'),
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminChuenaCursus',
        component: () => import('@/views/AdminChuenaCursus.vue'),
        beforeEnter: ensureAdminOrChuenaOrExt,
      },

      {
        path: 'templates',
        name: 'AdminChuenaTemplates',
        component: () => import('@/views/AdminChuenaTemplates.vue'),
        beforeEnter: ensureAdmin,
      },

      {
        path: 'payments',
        name: 'AdminChuenaPayments',
        component: () => import('@/views/AdminChuenaPayments.vue'),
        beforeEnter: ensureAdminOrAnalyst,
      },

      {
        path: 'initial-reviews',
        name: 'AdminChuenaInitialReviews',
        component: () => import('@/views/AdminChuenaInitialReviews.vue'),
        beforeEnter: ensureAdminOrAnalyst,
      },

      {
        path: 'cursus/:cursusId',
        name: 'AdminChuenaRegistrations',
        component: () => import('@/views/AdminChuenaRegistrations.vue'),
        props: true,
        beforeEnter: ensureAdminOrChuenaOrExt,
      },
    ],
    beforeEnter: (to, from, next) => {
      // eslint-disable-next-line max-len
      if (store.getters.hasAccessRole && (store.getters.hasAdminRole || store.getters.hasChuenaRole || store.getters.hasExtRole || store.getters.hasAnalystRole)) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },

  {
    path: '/admin/pss/:instanceId',
    component: () => import('@/views/AdminPara.vue'),
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminParaCursus',
        component: () => import('@/views/AdminParaCursus.vue'),
      },

      {
        path: 'cursus/:cursusId',
        name: 'AdminParaRegistrations',
        component: () => import('@/views/AdminParaRegistrations.vue'),
        props: true,
      },

      {
        path: 'cursus/:cursusId/registration/:registrationId',
        name: 'AdminParaRegistrationDetails',
        component: () => import('@/views/AdminParaRegistrationDetails.vue'),
        props: true,
      },

      {
        path: 'templates',
        name: 'AdminParaTemplates',
        component: () => import('@/views/AdminParaTemplates.vue'),
        beforeEnter: ensureAdmin,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (
        store.getters.hasAccessRole
        && (store.getters.hasAdminRole || store.getters.hasParaRole || store.getters.hasExtRole)
      ) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },

  {
    path: '/admin/enf/:instanceId',
    // name: 'AdminEnf',
    component: () => import('@/views/AdminEnf.vue'),
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminEnfCursus',
        component: () => import('@/views/AdminEnfCursus.vue'),
      },

      {
        path: 'templates',
        name: 'AdminEnfTemplates',
        component: () => import('@/views/AdminEnfTemplates.vue'),
        beforeEnter: ensureAdmin,
      },

      {
        path: 'cursus/:cursusId',
        name: 'AdminEnfRegistrations',
        component: () => import('@/views/AdminEnfRegistrations.vue'),
        props: true,
      },

      {
        path: 'cursus/:cursusId/registration/:registrationId',
        name: 'AdminEnfRegistrationDetails',
        component: () => import('@/views/AdminEnfRegistrationDetails.vue'),
        props: true,
      },
    ],
    beforeEnter: (to, from, next) => {
      // eslint-disable-next-line max-len
      if (store.getters.hasAccessRole && (store.getters.hasAdminRole || store.getters.hasEnfRole || store.getters.hasExtRole)) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },

  {
    path: '/admin/enfv/:instanceId',
    // name: 'AdminEnf',
    component: () => import('@/views/AdminEnfV.vue'),
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminEnfVCursus',
        component: () => import('@/views/AdminEnfVCursus.vue'),
      },

      {
        path: 'templates',
        name: 'AdminEnfVTemplates',
        component: () => import('@/views/AdminEnfVTemplates.vue'),
        beforeEnter: ensureAdmin,
      },

      {
        path: 'cursus/:cursusId',
        name: 'AdminEnfVRegistrations',
        component: () => import('@/views/AdminEnfVRegistrations.vue'),
        props: true,
      },

      {
        path: 'cursus/:cursusId/registration/:registrationId',
        name: 'AdminEnfVRegistrationDetails',
        component: () => import('@/views/AdminEnfVRegistrationDetails.vue'),
        props: true,
      },
    ],
    beforeEnter: (to, from, next) => {
      // eslint-disable-next-line max-len
      if (store.getters.hasAccessRole && (store.getters.hasAdminRole || store.getters.hasEnfvRole || store.getters.hasExtRole)) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },

  {
    path: '/admin/enr/:instanceId',
    // name: 'AdminEnr',
    component: () => import('@/views/AdminEnr.vue'),
    props: true,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'AdminEnrCursus',
        component: () => import('@/views/AdminEnrCursus.vue'),
      },

      {
        path: 'cursus/:cursusId(kine|logo)',
        name: 'AdminEnrRegistrations',
        component: () => import('@/views/AdminEnrRegistrations.vue'),
        props: true,
      },

      {
        path: 'templates',
        name: 'AdminEnrTemplates',
        component: () => import('@/views/AdminEnrTemplates.vue'),
        beforeEnter: ensureAdmin,
      },
    ],
    beforeEnter: (to, from, next) => {
      // eslint-disable-next-line max-len
      if (store.getters.hasAccessRole && (store.getters.hasAdminRole || store.getters.hasEnrRole || store.getters.hasExtRole)) {
        next();
      } else {
        next('/admin/instances');
      }
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters.isAuth) await store.dispatch('checkAuth');
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuth) next();
    else next('/admin/login');
  } else {
    next();
  }
});

export default router;
